module.exports = __webpack_public_path__ + "8d8230a6e6318b1a12365c3a17097aee.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatar.png
// module id = 1330
// module chunks = 0